<div class="host-house-price">
  <div class="v4-layout-form">
    <div class="v4-layout-form-title">
      {{ "operate_sidebar_html_日期" | translate }}
      <!-- Date -->
    </div>
    <div class="v4-layout-field">
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row justify-between">
          <host-range-picker
            class="flex-1 mr-5"
            [showFooter]="false"
            [size]="'large'"
            [disabledDate]="disabledDate"
            [(ngModel)]="dateRange"
            (ngModelChange)="changeDate($event)"></host-range-picker>
          <div class="extra">
            {{
              (nights > 1 ? "component.sidebar.plural.total_nights" : "component.sidebar.singular.total_nights")
                | translate
                  : {
                      nights: nights
                    }
            }}
            <!-- 共{{ nights }}晚 -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="v4-layout-form">
    <div class="v4-layout-form-title">{{ "component.sidebar.hprice_form_title_price" | translate }}</div>

    <div class="v4-filter-style mb-[16px]">
      <nz-radio-group [(ngModel)]="priceMode" nzButtonStyle="solid">
        <label nz-radio-button nzValue="edit">{{ "word.edit" | translate }}</label>
        <label nz-radio-button nzValue="copy">{{ "word.copy" | translate }}</label>
      </nz-radio-group>
    </div>

    <!-- @if (priceMode === "copy") {
      <div class="v4-layout-field">
        <div class="v4-layout-field-label w-[280px]"></div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">{{ "component.sidebar.hprice_form_item_copy_from" | translate }}</div>
        </div>
      </div>
    } -->

    <div class="v4-layout-field">
      <span class="v4-layout-field-label flex-1 first">
        {{
          (priceMode === "edit"
            ? "component.sidebar.hprice_form_item_change_all_price"
            : "component.sidebar.hprice_form_item_copy_from"
          ) | translate
        }}
        <!-- 一键改价 -->
      </span>
      <!--      <span class="label second"></span>-->
      <div
        class="v4-layout-field-control !flex-none"
        [ngClass]="{ 'w-[120px]': priceMode === 'edit', 'w-[200px]': priceMode === 'copy' }">
        <div class="v4-layout-field-row w-full">
          @if (priceMode === "edit") {
            <input nz-input class="input" nzSize="large" type="number" [(ngModel)]="price" />
          } @else {
            <nz-select
              class="w-full"
              nzSize="large"
              [nzOptions]="optionsOfCopySource"
              [nzDropdownMatchSelectWidth]="false"
              [(ngModel)]="copySource"></nz-select>
          }
        </div>
      </div>
    </div>
    @for (data of listOfDataByThirdparty; track data.unique_key) {
      @if (priceMode === "edit") {
        <host-edit-price-form-item
          [data]="data"
          [active]="entity?.c_id === data.house_info?.c_id"
          [disabled]="data?.house_info?.c_readonly"
          [displayThousandsSep]="displayThousandsSep"></host-edit-price-form-item>
      } @else {
        <host-copy-price-form-item
          [data]="data"
          [active]="entity?.c_id === data.house_info?.c_id"
          [disabled]="data?.house_info?.c_readonly || copySource === data.house_info?.c_id"
          (onCheckChange)="data.checked = $event"></host-copy-price-form-item>
      }
    }
  </div>

  <div class="v4-layout-form">
    <div>
      <a href="javascript:void(0)" (click)="onDisplayListingPr()">
        {{ "operate-sidebar_price_rules_html_listing_pr" | translate }}
        <!-- Listing pricing ratio -->
      </a>
    </div>
    <div class="mt-[16px]">
      <a routerLink="/app/settings/custom-options" [queryParams]="{ anchor: 'cpr' }">
        {{ "operate-sidebar_price_rules_html_global_pr" | translate }}
        <!-- Global pricing ratio -->
      </a>
    </div>
  </div>

  <!-- <div class="v4-layout-form">
    <div class="v4-layout-field">
      <div class="v4-layout-field-control">
        <a
          nz-button
          nzType="link"
          nzSize="small"
          routerLink="/app/settings/custom-options"
          [queryParams]="{ anchor: 'cpr' }"
          >{{ "word.set_channel_diff_price" | translate }}</a
        >
      </div>
    </div>
  </div> -->

  <footer class="bar-footer">
    <button nz-button nzSize="large" (click)="onClickCancel()">
      {{ "word.cancel" | translate }}
      <!-- 取消 -->
    </button>
    <button nz-button nzType="primary" nzSize="large" (click)="onClickSave()">
      {{ "word.save" | translate }}
      <!-- 保存 -->
    </button>
  </footer>
</div>
